/*
 * サブシステム名：
 * 機能名：定型コース一覧
 * 表示項目カスタマイズ(幸栄トランスポート)
 */
import D2MSTD0450 from '@/views/MST/D2MSTD0450.js'
// import filter from '@/rahmen/utils/filters'

export default {
  extends: D2MSTD0450,
  name: 'MstTeikeiCorceListCustomForKet',
  data: () => ({
    custoMizeHeaders: [
      { text: 'コースコード', value: 'teikeiKihonNo' },
      { text: 'コース名称', value: 'teikeiCourseNm' },
      { text: '得意先名称', value: 'tokuisakiDisp' },
      { text: '担当営業所', value: 'tantoEigyoshoDisp' },
      { text: '品種', value: 'hinmokuSbtNm' },
      { text: '商品', value: 'hinmeiNm' },
      { text: '商品備考', value: 'hinmeiBiko' },
      { text: '単位', value: 'unitKbnNm' },
      { text: '請求車種', value: 'seikyuShashuSbtNm' },
      { text: '発地', value: 'hatsuchiDisp' },
      { text: '発時刻', value: 'hatsuchiHmsDisp' },
      { text: '着地', value: 'chakuchiDisp' },
      { text: '着時刻', value: 'chakuchiHmsDisp' },
      { text: '運賃計算方法', value: 'unchinKeisanKbnNm' },
      { text: '単価', value: 'tanka', align: 'end' },
      { text: '高速代', value: 'hiwayPrice', align: 'end' },
      { text: '傭車額', value: 'yoshaUnchin', align: 'end' },
      { text: '傭車通行料', value: 'yoshaHiwayPrice', align: 'end' },
      { text: '請求用備考', value: 'seikyuBiko' },
      { text: '連絡用備考', value: 'renrakuBiko' }
    ]
  }),
  computed: {
  },
  methods: {
  }
}
